export const useFold = (data: boolean) => useState('unfold', () => data)
